export enum SiteMapUrl {
  MenuProject = 'project',
  MenuProductFormula = 'product-formula',
  MenuProduct = 'product-formula/p',
  MenuFormula = 'product-formula/f',
  MenuEnginAtelier = 'engin-atelier',
  MenuAcheminement = 'acheminement',
  MenuTransport = 'transport',
  MenuIndustry = 'industrie',
  MenuCombustible = 'combustible',
  MenuOrganisation = 'agency',
  MenuUser = 'user',
  MenuLogin = 'login',
  MenuSso = 'sso',
  MenuEnergie = 'energy',

  MenuEmail = 'email',
  MenuAdministration = 'administration',
  MenuStatistic = 'statistic',
  MenuStatisticProfile = 'statisticProfile',
  MenuMember = 'member',
  MenuAccount = 'account',
  MenuResetPassword = 'reset-password',
  MenuUserEntity = 'user-entity',
  MenuSynthese = 'synthese',
  MenuFormulaIndustry = 'industrie/formula',
  MenuStructure = 'structure',
  MenuStructureType = 'structure-type',
  MenuSubstructureType = 'substructure-type',
  MenuModality = 'modality',
  MenuTransportModality = 'transport-modality',
  MenuProjectsEcoPro = 'projects-ecopro',
  MenuUserEcoPro = 'user-ecopro',
  MenuCoeffMOE = 'coeff-MOE',
  MenuWorkInspection = 'work-inspection',
  MenuDredgingEquipment = 'dredging-equipment',
  MenuTunnelingEquipment = 'tunneling-equipment',
  MenuDredgingFuel = 'dredging-fuel',
  MenuCallForTender = 'call-for-tender',
  MenuTranslation = 'translations',
  MenuHelp = 'help',
  MenuPartnerApi = 'partner-api'
}
